import React from 'react';
import TrackingContainer from '../components/TrackingContainer';
import useStudents from '../hooks/useStudents';

const Tracking = () => {
  const { students, getAllStudents } = useStudents();
  return (
    <div className="p-8 bg-gray-100">
      <TrackingContainer getAllStudents={getAllStudents} students={students} />
    </div>
  );
};

export default Tracking;
